import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { DuplicableEntity } from "@mapmycustomers/shared/types/entity/Duplicate";
import { Alert } from "@mapmycustomers/ui";

import { getSelectedEntities } from "@app/scene/settings/component/MergeDuplicates/store";
import { RootState } from "@app/store/rootReducer";

interface Props {
  primary: DuplicableEntity;
  secondary: DuplicableEntity;
}

const OwnerWarning: React.FC<Props> = ({ primary, secondary }) => {
  const intl = useIntl();
  if (primary.user.id === secondary.user.id) {
    return null;
  }
  return (
    <div>
      <Alert
        description={intl.formatMessage({
          id: "settings.mergeDuplicates.previewMergePane.ownerWarning.description",
          defaultMessage:
            "Please note that the owner of the record selected as “primary” will take precedence. The new merged record may not be visible to the owner of the secondary record.",
          description:
            "Settings Merge duplicates - of preview/merge pane - description on owner warning",
        })}
        message={intl.formatMessage({
          id: "settings.mergeDuplicates.previewMergePane.ownerWarning.message",
          defaultMessage: "Duplicate records have different owners",
          description:
            "Settings Merge duplicates - of preview/merge pane - message on owner warning",
        })}
        showIcon
        type="warning"
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  primary: getSelectedEntities(state).primary!,
  secondary: getSelectedEntities(state).secondary!,
});

export default connect(mapStateToProps)(OwnerWarning);
